function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M62 31c0 17.12-13.88 31-31 31C13.88 62 0 48.12 0 31 0 13.88 13.88 0 31 0c17.12 0 31 13.88 31 31z",
  fill: "url(#skill_3_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48.256 33.496c1.781-1.187 1.781-3.805 0-4.992L32.664 18.109C30.67 16.78 28 18.21 28 20.606v20.788c0 2.397 2.67 3.826 4.664 2.497l15.592-10.395z",
  fill: "#fff",
  fillOpacity: 0.7
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.256 33.496c1.781-1.187 1.781-3.805 0-4.992L20.664 18.109C18.67 16.78 16 18.21 16 20.606v20.788c0 2.397 2.67 3.826 4.664 2.497l15.592-10.395z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "skill_3_svg__paint0_linear",
  x1: 31,
  y1: 0,
  x2: 31,
  y2: 62,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#864BD0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BE81CB"
})));

function SvgSkill3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 62",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjIgNjIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02MiAzMUM2MiA0OC4xMjA4IDQ4LjEyMDggNjIgMzEgNjJDMTMuODc5MiA2MiAwIDQ4LjEyMDggMCAzMUMwIDEzLjg3OTIgMTMuODc5MiAwIDMxIDBDNDguMTIwOCAwIDYyIDEzLjg3OTIgNjIgMzFaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxwYXRoIGQ9Ik00OC4yNTU4IDMzLjQ5NjJDNTAuMDM3IDMyLjMwODcgNTAuMDM3IDI5LjY5MTMgNDguMjU1OCAyOC41MDM4TDMyLjY2NDEgMTguMTA5NEMzMC42NzA0IDE2Ljc4MDMgMjggMTguMjA5NSAyOCAyMC42MDU2VjQxLjM5NDRDMjggNDMuNzkwNSAzMC42NzA0IDQ1LjIxOTcgMzIuNjY0MSA0My44OTA2TDQ4LjI1NTggMzMuNDk2MloiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8cGF0aCBkPSJNMzYuMjU1OCAzMy40OTYyQzM4LjAzNyAzMi4zMDg3IDM4LjAzNyAyOS42OTEzIDM2LjI1NTggMjguNTAzOEwyMC42NjQxIDE4LjEwOTRDMTguNjcwNCAxNi43ODAzIDE2IDE4LjIwOTUgMTYgMjAuNjA1NlY0MS4zOTQ0QzE2IDQzLjc5MDUgMTguNjcwNCA0NS4yMTk3IDIwLjY2NDEgNDMuODkwNkwzNi4yNTU4IDMzLjQ5NjJaIiBmaWxsPSJ3aGl0ZSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iMzEiIHkxPSIwIiB4Mj0iMzEiIHkyPSI2MiIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjODY0QkQwIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0JFODFDQiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgSkill3 as ReactComponent };